import { createElement } from "react";
import { Form, Link, Outlet, useLoaderData, NavLink } from "react-router";
import { RiDraftLine } from "react-icons/ri";
import { useNavigate, useParams, useLocation } from "react-router"

import { useEffect, useRef, useState, } from "react";
import { BiArrowBack, BiX } from "react-icons/bi";
import Select from 'react-select';
import { IoMdMore, IoMdMenu, IoMdHome, IoIosClose, IoIosSettings, IoIosCash, IoIosContract, IoMdTrendingUp, IoMdStats, IoMdToday, IoIosPeople, IoIosPlanet, IoIosRemove, IoMdPeople } from "react-icons/io";
import { IoConstructOutline, IoChevronDown, IoChevronUp, IoChevronForward, IoHomeOutline, IoTicketOutline, IoSparklesOutline, IoSettingsOutline, IoLockClosedOutline, IoAppsOutline, IoClipboardOutline, IoMedalOutline, IoPeopleOutline, IoFileTrayFullOutline, IoFileTrayStackedOutline, IoNotificationsOutline, IoLogOutOutline, IoTimeOutline, IoCloudUploadOutline, IoLibraryOutline, IoWarningOutline } from "react-icons/io5";
import { BiSupport, BiSolidCarousel } from "react-icons/bi";
import { TbMessageChatbot, TbDatabase } from "react-icons/tb";

import { useNavigationStore } from "../../store/navigationStore";
import { useBenefitPlanStore } from "../../store/benefitPlanStore";
import centivoLog from '../../assets/centivo-favicon.png';

import { BsJournalCode } from "react-icons/bs";

import { GoCodeOfConduct } from "react-icons/go";
import { BsFileEarmarkMedical } from "react-icons/bs";
import { PiNetworkXBold } from "react-icons/pi";

import { useAuthStore } from "../../store/authStore";
import { INTERNAL_NAV } from "../internal/internalDesks.js";
import { useAvatarTheme } from "../settings/useAvatarTheme";
import { logOut } from "../../utils/fetchUtils";
import { FaUsersViewfinder } from "react-icons/fa6";
import { LuHospital } from "react-icons/lu";


const Sidebar = () => {

    const location = useLocation();
    const { isSideBarOpen } = useNavigationStore()

    const { roles } = useAuthStore();

    const topMenuOptions = [

        {
            to: '/',
            label: 'Home',
            isActive: location.pathname === '/',
            icon: IoHomeOutline,
            alwaysShow: true,
        },
        // this work is in progress (One source of truth)
        {
            to: '/internal',
            label: 'Internal',
            alwaysShow: true,
            isActive: location.pathname.startsWith('/internal'),
            icon: RiDraftLine,
            subOptions: INTERNAL_NAV.map((item) => ({
                label: item.label,
                to: item.to,
                isActive: item.id === 'guide'
                    ? location.pathname === '/internal' || location.pathname.startsWith('/internal/guide')
                    : location.pathname === item.to || location.pathname.startsWith(`${item.to}/`),
            })),
        },
        {
            to: '/commercial',
            label: 'Commercial',
            allowedRoles: ['proposal'],
            isActive: location.pathname.startsWith('/commercial'),
            icon: IoIosCash,
            subOptions: [
                { label: 'Proposal', to: '/commercial/proposal', isActive: location.pathname.startsWith('/commercial/proposal') },
            ],
        },
        // {
        //     to: '/projects',
        //     label: 'Projects',
        //     isActive: location.pathname === '/projects',
        //     icon: IoClipboardOutline
        // },

        // {
        //     to: '/vendors',
        //     label: 'vendors',
        //     isActive: location.pathname === '/vendors',
        //     icon: IoIosPlanet
        // },
        // {
        //     to: '/tickets',
        //     label: 'tickets',
        //     icon: IoTicketOutline
        // },
        // {
        //     to: '/sales',
        //     label: 'sales',
        //     isActive: location.pathname.includes('/sales/assets'),
        //     icon: IoMedalOutline,
        //     subOptions: [
        //         { label: 'Assets', to: '/sales/assets', isActive: location.pathname.includes('/sales/assets'), },
        //         { label: 'Proposal', to: '/sales/proposal', isActive: location.pathname.includes('/sales/proposal'), }
        //     ]
        // },
        // {
        //     to: '/legal',
        //     label: 'legal',
        //     isActive: location.pathname.includes('/legal'),
        //     icon: IoIosContract,
        //     subOptions: [
        //         { label: 'Contract', to: '/legal/contract', isActive: location.pathname.includes('/legal/contract'), }
        //     ]
        // },
        {
            to: '/jv',
            allowedRoles: ['jv'],
            label: 'Javelina',
            isActive: location.pathname.includes('jv'),
            icon: IoFileTrayStackedOutline,
            subOptions: [
                { label: 'Clients', to: '/jv/clients', isActive: location.pathname.includes('/jv/clients'), },
                { label: 'Employees', to: '/jv/employees', isActive: location.pathname.includes('/jv/employees'), },
                { label: 'Claims', to: '/jv/claims', isActive: location.pathname.includes('/jv/claims'), },
                { label: 'Reinsurance', to: '/jv/reinsurance', isActive: location.pathname.includes('/jv/reinsurance'), },
                // { label: 'Brokers', to: '/jv/brokers', isActive: location.pathname.includes('/jv/brokers'), },
                // { label: 'BankAccount', to: '/jv/bank-account', isActive: location.pathname.includes('/jv/bank-account'), },
                // { label: 'Payments', to: '/jv/payments', isActive: location.pathname.includes('/jv/payments'), },
                { label: 'Check Journals', to: '/jv/daily-check-journal', isActive: location.pathname.includes('/jv/daily-check-journal'), },
            ]
        },

        {
            to: '/config',
            allowedRoles: ['config'],
            label: 'Configuration',
            isActive: location.pathname === '/config' || location.pathname.startsWith('/config/'),
            icon: IoConstructOutline,
            subOptions: [
                { label: 'Guide', to: '/config/guide', isActive: location.pathname.includes('/config/guide'), },
                { label: 'Audit', to: '/config/audit', isActive: location.pathname.includes('/config/audit'), },
                { label: 'Accounts', to: '/config/accounts', isActive: location.pathname === '/config/accounts', },
                { label: 'Account Hierarchy', to: '/config/account-hierarchy', isActive: location.pathname.includes('/config/account-hierarchy'), },
                { label: 'Account Builder', to: '/config/account-builder', isActive: location.pathname.includes('/config/account-builder'), },
                { label: 'Account Audit', to: '/config/account-audit', isActive: location.pathname.includes('/config/account-audit') },
                { label: 'Department Builder', to: '/config/department-builder', isActive: location.pathname.includes('/config/department-builder'), },
                { label: 'Templates', to: '/config/templates', isActive: location.pathname.includes('/config/templates'), },


                { label: 'Components', to: '/config/components', isActive: location.pathname.includes('/config/components'), },
                { label: 'Network Definitions', to: '/config/network-definitions', isActive: location.pathname.includes('/config/network-definitions') },


                { label: 'Value List', to: '/config/value-list', isActive: location.pathname === '/config/value-list' },
                { label: 'Provisions', to: '/config/provisions', isActive: location.pathname === '/config/provisions' },

                { label: 'Service Cateogires', to: '/config/service-categories', isActive: location.pathname.includes('/config/service-categories'), },

                //service-categories
                // { label: 'Components', to: '/config/components', isActive: location.pathname.includes('/config/components'), },
                // { label: 'Riders', to: '/config/riders', isActive: location.pathname.includes('/config/riders') },
                { label: 'Benefit plans', to: '/config/plans', isActive: location.pathname.includes('/config/plans'), },
                // { label: 'Builde POC', to: '/config/builder-poc', isActive: location.pathname === '/config/builder-poc' },

                { label: 'Plan Builder', to: `/config/plan-builder`, isActive: location.pathname.includes('/config/plan-builder'), },
                { label: 'Migrate', to: `/config/migrate`, isActive: location.pathname === '/config/migrate' }

            ]
        },
        {
            to: '/notifications',
            allowedRoles: ['notifications'],
            label: 'Notifications',
            isActive: location.pathname.startsWith('/notifications'),
            icon: IoNotificationsOutline,
            subOptions: [
                {
                    label: 'Outbox',
                    to: '/notifications/outbox',
                    isActive: location.pathname === '/notifications' || location.pathname.startsWith('/notifications/outbox'),
                },
                {
                    label: 'Test Email Template',
                    to: '/notifications/test-email-template',
                    isActive: location.pathname.startsWith('/notifications/test-email-template'),
                },
            ]
        },
        {
            to: '/plan-manager',
            allowedRoles: ['client-ops', 'client-impl'],
            label: 'Plan Manager',
            isActive: location.pathname.startsWith('/plan-manager'),
            icon: IoClipboardOutline,
            subOptions: [
                {
                    label: 'Plans',
                    to: '/plan-manager/plans',
                    isActive: location.pathname === '/plan-manager' || location.pathname.startsWith('/plan-manager/plans'),
                },
                {
                    label: 'Networks',
                    to: '/plan-manager/networks',
                    isActive: location.pathname.startsWith('/plan-manager/networks'),
                },
                {
                    label: 'Pre-enrollment custom',
                    to: '/plan-manager/pre-enrollment-custom',
                    isActive: location.pathname.startsWith('/plan-manager/pre-enrollment-custom'),
                },
            ]
        },
        {
            to: '/codes',
            allowedRoles: ['config', 'claims'],
            label: 'Codes',
            isActive: location.pathname.includes('codes'),
            icon: BsFileEarmarkMedical,
            subOptions: [
                { label: 'Services', to: '/codes/services', isActive: location.pathname === '/codes/services' },
                { label: 'Revenue', to: '/codes/revenue', isActive: location.pathname === '/codes/revenue' },
                { label: 'Drugs', to: '/codes/drugs', isActive: location.pathname === '/codes/drugs' },
                { label: 'Diagnosis', to: '/codes/diagnosis', isActive: location.pathname === '/codes/diagnosis' },
                { label: 'Procedures', to: '/codes/procedures', isActive: location.pathname === '/codes/procedures' },
                { label: 'Place of Service', to: '/codes/place-of-service', isActive: location.pathname === '/codes/place-of-service' },
                { label: 'Type of Bill', to: '/codes/type-of-bill', isActive: location.pathname === '/codes/type-of-bill' },
                { label: 'Modifiers', to: '/codes/modifiers', isActive: location.pathname === '/codes/modifiers' },
                { label: 'Taxonomy', to: '/codes/taxonomy', isActive: location.pathname === '/codes/taxonomy' },
                { label: 'Condition', to: '/codes/condition', isActive: location.pathname === '/codes/condition' },
                { label: 'Occurrence', to: '/codes/occurrence', isActive: location.pathname === '/codes/occurrence' },
                { label: 'Code Entries', to: '/codes/code-entries', isActive: location.pathname === '/codes/code-entries' },
            ],


        },
        {
            to: '/members',
            label: 'members',
            allowedRoles: ['members'],
            isActive: location.pathname === '/members',
            icon: FaUsersViewfinder
        },
        {
            to: '/coverage',
            label: 'Coverage',
            allowedRoles: ['config', 'members'],
            isActive: location.pathname.includes('/coverage'),
            icon: IoClipboardOutline
        },
        {
            to: '/claims',
            allowedRoles: ['claims'],
            label: 'claims',
            isActive: location.pathname.startsWith('/claims'),
            icon: IoMdToday,
            subOptions: [
                { label: 'Guide', to: '/claims/guide', isActive: location.pathname === '/claims/guide' },
                { label: 'Search', to: '/claims', isActive: location.pathname === '/claims' },
            ]
        },
        {
            to: '/providers',
            allowedRoles: ['providers'],
            label: 'Providers',
            isActive: location.pathname.includes('provider'),
            icon: LuHospital,
            subOptions: [
                { label: 'Guide', to: '/providers/guide', isActive: location.pathname === '/providers/guide' },
                { label: 'Suppliers', to: '/providers/suppliers', isActive: location.pathname === '/providers/suppliers' },
                { label: 'Practitioners', to: '/providers/practitioners', isActive: location.pathname === '/providers/practitioners' },
                { label: 'Roles', to: '/providers/roles', isActive: location.pathname === '/providers/roles' },
                { label: 'Networks', to: '/providers/networks', isActive: location.pathname === '/providers/networks' },
                { label: 'Supplier Contracts', to: '/providers/contracts', isActive: location.pathname === '/providers/contracts' },
                { label: 'Fee Components', to: '/providers/fee-components', isActive: location.pathname === '/providers/fee-components' },
            ]
        },
        {
            to: '/edi',
            allowedRoles: ['edi'],
            label: 'Edi',
            isActive: location.pathname.includes('edi'),
            icon: IoFileTrayFullOutline,
            subOptions: [
                { label: 'Ingestion', to: '/edi/ingestion', isActive: location.pathname === '/edi/ingestion' },
                // { label: 'Outbound', to: '/edi/outbound' }
                { label: 'EDI Extract Self-Service', to: '/edi/extract', isActive: location.pathname === '/edi/extract' }
            ]
        },

        {
            to: '/access',
            label: 'access',
            isActive: location.pathname.startsWith('/access'),
            icon: IoPeopleOutline,
            subOptions: [
                { label: 'Users', to: '/access', isActive: location.pathname === '/access' },
                { label: 'Roles', to: '/access/roles', isActive: location.pathname.startsWith('/access/roles') },
            ],
        },
        {
            to: '/dynamodb',
            allowedRoles: ['dynamodb'],
            label: 'Dynamo DB',
            isActive: location.pathname.includes('dynamodb'),
            icon: TbDatabase,
            subOptions: [
                { label: 'Hrp', to: '/dynamodb/hrp', isActive: location.pathname === '/dynamodb/hrp' },
                { label: 'Business', to: '/dynamodb/business', isActive: location.pathname === '/dynamodb/business' },
                { label: 'PcpTransactions', to: '/dynamodb/pcp-transactions', isActive: location.pathname === '/dynamodb/pcp-transactions' },
                { label: 'Notification', to: '/dynamodb/notification', isActive: location.pathname === '/dynamodb/notification' },
                { label: 'BenefitPlans', to: '/dynamodb/benefitplans', isActive: location.pathname === '/dynamodb/benefitplans' },
                { label: 'NotificationJobRegistry', to: '/dynamodb/notifications-job-registry', isActive: location.pathname === '/dynamodb/notifications-job-registry' },
                { label: 'Referral', to: '/dynamodb/referral', isActive: location.pathname === '/dynamodb/referral' },
                { label: 'ClaimAndAccumulator', to: '/dynamodb/claim-and-accumulator', isActive: location.pathname === '/dynamodb/claim-and-accumulator' },
                { label: 'Member', to: '/dynamodb/member', isActive: location.pathname === '/dynamodb/member' },
                { label: 'FinanceInboundInvoices', to: '/dynamodb/finance-inbound-invoices', isActive: location.pathname === '/dynamodb/finance-inbound-invoices' }
            ].sort((a, b) => a.label.localeCompare(b.label))
        },
        {
            to: '/athena',
            allowedRoles: ['dynamodb'],
            label: 'Athena',
            isActive: location.pathname.includes('/athena'),
            icon: IoMdStats,
            subOptions: [
                { label: 'service_member', to: '/athena/service-member', isActive: location.pathname.includes('/athena/service-member') || location.pathname === '/athena' },
            ]
        },
        // {
        //     to: '/logs',
        //     label: 'logs',
        //     allowedRoles: ['logs'],
        //     isActive: location.pathname.includes('logs'),
        //     icon: BiSolidCarousel,
        //     // subOptions: [
        //     //     { label: 'Tickets', to: '/support/tickets', isActive: location.pathname.includes('/support/tickets') },

        //     // ]
        // },

        {
            to: '/support',
            label: 'support',
            allowedRoles: ['support'],
            isActive: location.pathname.includes('support'),
            icon: BiSupport,
            subOptions: [
                // { label: 'IT Helpdesk', to: '/support/it' },
                // { label: 'Provider', to: '/support/provider' },
                // { label: 'Member', to: '/support/member' },
                { label: 'Tickets', to: '/support/tickets', isActive: location.pathname.includes('/support/tickets') },
                { label: 'QInConnect', to: '/support/q-in-connect', isActive: location.pathname.includes('/support/q-in-connect') }
            ]
        },
        // {
        //     to: '/chatbots',
        //     label: 'chatbots',
        //     isActive: location.pathname.includes('/chatbots'),
        //     icon: TbMessageChatbot,
        //     subOptions: [
        //         { label: 'Client and Plans', to: '/chatbots/plans', isActive: location.pathname.includes('/chatbots/plans'), },
        //         // { label: 'Proposal', to: '/sales/proposal', isActive: location.pathname.includes('/sales/proposal'), }
        //     ]
        // },
        {
            to: '/agents',
            label: 'Agents',
            allowedRoles: ['member-care', 'finance', 'admin', 'agents'],
            isActive: location.pathname.startsWith('/agents'),
            icon: TbMessageChatbot,
        },
        {
            to: '/member-care',
            label: 'Member Care',
            allowedRoles: ['member-care'],
            isActive: location.pathname.includes('/member-care'),
            icon: BiSupport,
            subOptions: [
                { label: 'Chatbot', to: '/member-care/chatbot', isActive: location.pathname.includes('/member-care/chatbot') },
                // { label: 'KnowledgeBase', to: '/member-care/knowledge-base', isActive: location.pathname.includes('/member-care/knowledge-base') },
                { label: 'Call Summary', to: '/member-care/call-summary', isActive: location.pathname.includes('/member-care/call-summary') }

            ]
        },
        {
            to: '/finance',
            label: 'Finance',
            allowedRoles: ['finance'],
            isActive: location.pathname.includes('/finance'),
            icon: IoMdTrendingUp,
            subOptions: [
                { label: 'Guide', to: '/finance/guide', isActive: location.pathname.includes('/finance/guide') },
                { label: 'Docs', to: '/finance/docs', isActive: location.pathname.includes('/finance/docs') },
                { label: 'Ops', to: '/finance/ops', isActive: location.pathname.includes('/finance/ops') },
                { label: 'CDES', to: '/finance/cdes', isActive: location.pathname.includes('/finance/cdes') },
                { label: 'Bills', to: '/finance/bills', isActive: location.pathname.includes('/finance/bills') },
                { label: 'Review Invoices', to: '/finance/client-documents/review-invoices', isActive: location.pathname.includes('/finance/client-documents/review-invoices'), isChild: true },
                { label: 'Review Check-Registers', to: '/finance/client-documents/review-check-registers', isActive: location.pathname.includes('/finance/client-documents/review-check-registers'), isChild: true },
                { label: 'Funding', to: '/finance/funding-requests', isActive: location.pathname.includes('/finance/funding-requests') },
                { label: 'Payment cycles', to: '/finance/payment-cycles', isActive: location.pathname.includes('/finance/payment-cycles') },
                { label: 'Billing rates', to: '/finance/billing-rates', isActive: location.pathname.includes('/finance/billing-rates') },
                { label: 'Premium payments', to: '/finance/payments', isActive: location.pathname.includes('/finance/payments') || location.pathname.includes('/finance/premium-payments') },
                { label: 'JV Check Journals', to: '/jv/daily-check-journal', isActive: location.pathname.includes('/jv/daily-check-journal'), },
                { label: 'Billing Rate Builder', to: '/finance/billing-rate-builder', isActive: location.pathname.includes('/finance/billing-rate-builder'), },
                { label: 'HRP Check Generator', to: '/finance/hrp-check-report-generator', isActive: location.pathname.includes('/finance/hrp-check-report-generator') },
                { label: 'Inbound Invoices', to: '/finance/inbound-invoices', isActive: location.pathname.includes('/finance/inbound-invoices') },
                {
                    label: 'Vendor Invoices',
                    to: '/finance/vendor-invoices',
                    isActive: location.pathname.includes('/finance/vendor-invoices'),
                    children: [
                        {
                            label: 'Vendor Configuration',
                            to: '/finance/vendor-invoices/vendors',
                            isActive: location.pathname.includes('/finance/vendor-invoices/vendors'),
                        },
                    ],
                },
                // { label: 'Chatbot', to: '/finance/chatbot', isActive: location.pathname.includes('/finance/chatbot'), }
            ]
        },
        {
            to: '/analytics',
            label: 'Analytics Upload',
            allowedRoles: ['finance'],
            isActive: location.pathname.includes('/analytics'),
            icon: IoCloudUploadOutline,
        },
        {
            to: '/stoploss',
            label: 'Stop Loss',
            allowedRoles: ['stoploss'],
            isActive: location.pathname.includes('/stoploss'),
            icon: IoWarningOutline,
            subOptions: [
                { label: 'HRP Hold Report Self-Service', to: '/stoploss', isActive: location.pathname.includes('/stoploss') }
            ]
        },
        {
            to: '/monitoring',
            label: 'Monitoring',
            allowedRoles: ['job-monitoring'],
            isActive: location.pathname.includes('/monitoring'),
            icon: PiNetworkXBold,
            subOptions: [
                { label: 'Jobs', to: '/monitoring/jobs', isActive: location.pathname.includes('/monitoring/jobs'), },
                { label: 'Groups', to: '/monitoring/groups', isActive: location.pathname.includes('/monitoring/groups') },
                { label: 'Cognito', to: '/monitoring/cognito', isActive: location.pathname.includes('/monitoring/cognito') }
            ]
        },



        // {
        //     to: '/apps',
        //     label: 'Apps',
        //     icon: IoAppsOutline,
        //     isActive: location.pathname.includes('digital-assests'),
        // },

    ].filter(m => m.alwaysShow || roles.includes('admin') || roles.some(r => m.allowedRoles && m.allowedRoles.includes(r)))

    const bottomMenuOptions = [
        {
            to: '/hrp-docs',
            label: 'HRP Docs',
            alwaysShow: true,
            isActive: location.pathname.startsWith('/hrp-docs'),
            icon: IoLibraryOutline,
        },
    ].filter(m => m.alwaysShow || roles.includes('admin') || roles.some(r => m.allowedRoles && m.allowedRoles.includes(r)))


    return (
        <div className={`sidebar ${isSideBarOpen ? '' : 'collapsed'}`}>
            <div className="top">
                {topMenuOptions.map(obj => <SideBarOption
                    {...obj}
                    key={obj.label}
                />)}
            </div>

            <div className="bottom" >
                <SidebarClock />
                {bottomMenuOptions.map(obj => <SideBarOption
                    {...obj}
                    key={obj.label}
                />)}
                <SidebarFooter />
            </div>

        </div>
    )
}

export default Sidebar

const SidebarClock = () => {
    const { isSideBarOpen } = useNavigationStore();
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const timerId = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(timerId);
    }, []);

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localTime = now.toLocaleString();

    return (
        <div
            className="sidebar-clock"
            title={!isSideBarOpen ? `${timeZone} · ${localTime}` : undefined}
        >
            <IoTimeOutline size="1.2rem" />
            {isSideBarOpen && (
                <div>
                    <p>{timeZone}</p>
                    <p>{localTime}</p>
                </div>
            )}
        </div>
    );
};

const SidebarFooter = () => {
    const { isSideBarOpen } = useNavigationStore();
    const navigate = useNavigate();
    const location = useLocation();
    useAvatarTheme();

    return (
        <div style={{ width: '100%' }}>
            <div
                className={`sidebar-option ${location.pathname.startsWith('/settings') ? 'isActive' : ''}`}
                title={!isSideBarOpen ? 'Settings' : undefined}
                onClick={() => navigate('/settings')}
            >
                <IoSettingsOutline size="1.2rem" />
                <p>Settings</p>
            </div>

            <div
                className="sidebar-option"
                title={!isSideBarOpen ? 'Logout' : undefined}
                onClick={async () => await logOut()}
            >
                <IoLogOutOutline size="1.2rem" color="var(--red)" />
                <p style={{ color: 'var(--red)' }}>Logout</p>
            </div>
        </div>
    );
};

const SideBarOption = ({ isActive, icon, to, color, label, subOptions }) => {
    const navigate = useNavigate()
    const { isSideBarOpen, setIsSideBarOpen, expandedSideBarOption, setExpandedSideBarOption } = useNavigationStore()

    const isExpanded = expandedSideBarOption === to && isSideBarOpen

    return <>
        <div
            className={`sidebar-option ${isActive ? 'isActive' : ''}`}
            title={!isSideBarOpen ? label : undefined}
            onClick={() => {
                if (isExpanded) {
                    setExpandedSideBarOption('')
                } else if (subOptions) {
                    setIsSideBarOpen(true)
                    setExpandedSideBarOption(to)
                } else {
                    navigate(to)
                }
            }}
        >
            {createElement(icon, { color, size: '1.2rem' })}
            <p>{label}</p>
            {subOptions && isSideBarOpen && (
                isExpanded
                    ? <IoChevronUp size=".8rem" style={{ flexShrink: 0 }} />
                    : <IoChevronDown size=".8rem" style={{ flexShrink: 0 }} />
            )}
        </div>

        {isExpanded && subOptions && (
            <div style={{ width: '100%', overflow: 'hidden' }}>
                {subOptions.map(subOpt => (
                    <div className={`sidebar-option-sub-menu-items${subOpt.isChild ? ' sidebar-option-sub-menu-items--child' : ''}`} key={subOpt.label}>
                        <p
                            className={`sidebar-option-sub-menu-item ${subOpt.isActive ? 'isActive' : ''}`}
                            onClick={() => navigate(subOpt.to)}
                        >
                            {subOpt.label}
                        </p>
                        {Array.isArray(subOpt.children) && subOpt.children.length > 0 && (
                            <div style={{ paddingLeft: "0.75rem" }}>
                                {subOpt.children.map((child) => (
                                    <p
                                        key={child.label}
                                        className={`sidebar-option-sub-menu-item ${child.isActive ? 'isActive' : ''}`}
                                        style={{ fontSize: "0.85em", opacity: 0.95 }}
                                        onClick={() => navigate(child.to)}
                                    >
                                        {child.label}
                                    </p>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        )}
    </>
}
